import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Auth } from './auth';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private auth: Auth, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const requiredRole = route.data && route.data.role;

    return new Promise<boolean>((resolve) => {
      this.auth.getUser().subscribe(
        (user) => {
          if (user && user.token) {
            // Autenticado: si la ruta exige un rol, validar que coincida
            if (requiredRole && user.roleId !== requiredRole) {
              this.router.navigate(['home']);
              resolve(false);
              return;
            }
            resolve(true);
          } else {
            this.router.navigate(['login']);
            resolve(false);
          }
        },
        () => {
          this.router.navigate(['login']);
          resolve(false);
        }
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/providers/auth.guard.ts